import { Button, Col, Form, Input, Modal, Row, Switch } from "antd";
import Variacio from "../../../model/menudesign/Variacio";
import { BiCheck, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";
import { PostVariants } from "../../../dao/menudesign/PostVariants";

interface IngredientModalProps {
    element: Variacio;
    visible: boolean;
    page: string;
    editar?: boolean;
    onClose: () => void;
}

const VariacioModal: React.FC<IngredientModalProps> = ({element, visible, page, editar, onClose}) => {
    const [form] = Form.useForm();
    async function handleSubmit() {
        const id = await form.getFieldValue('id');
        const nom = await form.getFieldValue('nom');
        const comentaris = await form.getFieldValue('comentaris');
        const estat = await form.getFieldValue('estat');
        await PostVariants(id,nom,comentaris,estat,page);
        await onClose();
    };
    async function handleCancel() {
        await onClose();
    };
    return (
        <Modal
            title="Crear/Editar Variants"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={1000}
        >
            <Form form={form} initialValues={element}>
                <Row gutter={[16, 16]}>
                    <Col span={42}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom">
                            <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Comentaris" name="comentaris">
                            <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Estat" name="estat">
                            <Switch/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};
export default VariacioModal;